import { Dispatch, useEffect } from 'react';
import { SetURLSearchParams } from 'react-router-dom';

import { useCampaignsListFiltersStorage } from '@features/campaigns/list/components/Filters/hooks/useFilters.ts';
import {
  CampaignListReducerAction,
  CampaignListReducerState,
} from '@features/campaigns/list/types/campaignListReducer.ts';
import {
  readCampaignListFilters,
  writeCampaignListFilters,
} from '@features/campaigns/list/utils/campaignListFiltersStorage.ts';
import {
  buildCampaignListStoredFilters,
  hydrateCampaignListFiltersFromStorage,
  syncCampaignListFiltersToUrlSearchParams,
} from '@features/campaigns/list/utils/campaignListFiltersSync.ts';

interface FiltersURLSearchParamsType {
  state: CampaignListReducerState;
  searchParams: URLSearchParams;
  dispatch: Dispatch<CampaignListReducerAction>;
  setSearchParams: SetURLSearchParams;
}

export const useFiltersURLSearchParams = ({
  state,
  searchParams,
  setSearchParams,
  dispatch,
}: FiltersURLSearchParamsType) => {
  const { userId } = useCampaignsListFiltersStorage();

  useEffect(() => {
    if (!userId) {
      return;
    }

    const storedFilters = readCampaignListFilters(userId);

    if (storedFilters) {
      const nextSearchParams = hydrateCampaignListFiltersFromStorage(storedFilters, dispatch, searchParams);

      setSearchParams(nextSearchParams);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      return;
    }

    setSearchParams(syncCampaignListFiltersToUrlSearchParams(searchParams, state));
    writeCampaignListFilters(userId, buildCampaignListStoredFilters(state));
  }, [userId, state.search, state.filters]);
};
